import { createFileRoute } from "@tanstack/react-router";

import Audit from "~/pages/UsdaAuditFeedback/Audit";
import { ROUTE_STATIC } from "~/utils/routeStaticData";

export const Route = createFileRoute("/_private/usda-audit-feedback/audit")({
  staticData: ROUTE_STATIC.usdaAuditFeedback,
  component: Audit,
});
